export default {
    tooltip: {
        add: {
            workspace: 'Add to a work space',
            innovationfield: 'Add to an innovation field',
            innovationfieldOrWorkspace: 'Add to a work space or an innovation field'
        },
        remove: {
            workspace: 'Remove macro-trend from this work space'
        }
    },
    noTranslation: 'no English translation available',
    noAction: 'Sign up for a premium account<br />to view all content.'
}
